import { NgModule } from '@angular/core';
import { TagsComponent } from './tags/tags.component';
import { CenterModalComponent } from './center-modal/center-modal.component';
import { SubscribeComponent } from './subscribe/subscribe.component';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonCheckbox, IonRippleEffect, IonToolbar, IonButton, IonCard, IonCardContent, IonCardTitle, IonCardSubtitle, IonInput, IonChip, IonLabel, IonIcon, IonTitle, IonHeader, IonContent, IonItem, IonSelect, IonSelectOption, IonDatetime, IonDatetimeButton, IonModal, IonSpinner, IonToggle } from "@ionic/angular/standalone";
import { ReconcileComponent } from './reconcile/reconcile.component';
import { ReconcileTransactionComponent } from './reconcile-transaction/reconcile-transaction.component';
import { PipesModule } from 'src/pipes/pipes.module';
import { SummaryComponent } from './summary/summary.component';

@NgModule({
    declarations: [
        CenterModalComponent,
        SubscribeComponent,
        TagsComponent,
        ReconcileComponent,
        ReconcileTransactionComponent,
        SummaryComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        PipesModule,
        IonCheckbox,
        IonRippleEffect,
        IonToolbar,
        IonButton,
        IonCard,
        IonCardContent,
        IonCardTitle,
        IonCardSubtitle,
        IonToolbar,
        IonButton,
        IonInput,
        IonChip,
        IonLabel,
        IonIcon,
        IonHeader,
        IonTitle,
        IonContent,
        IonItem,
        IonSelect,
        IonSelectOption,
        IonDatetime,
        IonDatetimeButton,
        IonModal,
        IonSpinner,
        IonToggle
    ],
    providers: [CurrencyPipe],
    exports: []
}) export class ComponentsModule { }
